import brakesList from './List'
import brakesShow from './Show'
import brakesEdit from './Edit'

const brakesResource = {
  list: brakesList,
  show: brakesShow,
  edit: brakesEdit,
}

export default brakesResource
